export const ConfirmationIcon = () => {
  return (
    <svg viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52.966 13.1h-2.323V9.228h-3.87v3.87H21.227V9.23h-3.87v3.87h-2.323a5.812 5.812 0 0 0-5.805 5.806v16.23a15.954 15.954 0 0 1 3.87-1.838V27.42h41.802v25.546a1.937 1.937 0 0 1-1.935 1.935H32.702a16.028 16.028 0 0 1-2.366 3.87h22.63a5.812 5.812 0 0 0 5.806-5.805V18.905a5.812 5.812 0 0 0-5.806-5.806ZM13.099 23.55h41.802v-4.645a1.937 1.937 0 0 0-1.935-1.935h-2.323v3.87h-3.87v-3.87H21.227v3.87h-3.87v-3.87h-2.323a1.937 1.937 0 0 0-1.935 1.935v4.644Z"
        fill="currentColor"
      />
      <path
        d="M33.841 50.837h2.094v-3.87h-2.014a16.219 16.219 0 0 1-.08 3.87Zm-.801-7.741h2.895v-3.87h-3.87v1.704c.376.693.703 1.416.975 2.166Zm-5.998-7.741h1.152v-3.87h-3.87v2.366c.958.414 1.868.919 2.718 1.504Zm-6.589-2.621v-1.25h-3.87v1.118a16.275 16.275 0 0 1 3.87.132Zm11.612-1.25h3.87v3.87h-3.87v-3.87Zm7.741 0h3.87v3.87h-3.87v-3.87Zm7.741 0h3.87v3.87h-3.87v-3.87Zm-7.741 7.741h3.87v3.87h-3.87v-3.87Zm0 7.741h3.87v3.87h-3.87v-3.87Zm7.741-7.741h3.87v3.87h-3.87v-3.87Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.971 61.686c7.243 0 13.115-5.872 13.115-13.115 0-7.242-5.872-13.114-13.114-13.114-7.243 0-13.115 5.872-13.115 13.114 0 7.243 5.872 13.115 13.114 13.115Zm7.363-16.863a1.457 1.457 0 0 0-2.235-1.87l-7.131 8.52-3.303-2.778a1.457 1.457 0 1 0-1.876 2.23l4.2 3.534a1.746 1.746 0 0 0 2.462-.216l7.883-9.42Z"
        fill="currentColor"
      />
    </svg>
  );
};
